<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_kullanicilari"  url="SupplierCreateUser" :show_button="true" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>

<div class="content_card_content">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-else>
  <ContentTable :data="data" :columns="columns" routename="SupplierUser" deleteobjectname="supplieruser" @dataDeleted="getData" identifier_row="user_id" identifier_row_name="user_id"></ContentTable>
</template>



</div>





</div>







</div>
</template>

<script>
export default {

  name: 'SupplierUsers',

  data () {
    return {
      data:[],
      loading:true,
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
      },
      {
        type:"relation",
        field:"user",
        relation_field:"email",
        header:"email",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"phone",
        header:"telefon",
        hide_on_mobile:false,
      },
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ], 
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      this.loading = true
      let data = await this.generalApiGetWithoutLoader("supplier/users/"+this.$route.params.id) 
      for(let item of data)
      {
        item.user_id = await item.id
      }
      this.data = await data
      await console.log(this.data)
      this.loading = false

    },
    
  }
}
</script>

<style lang="css" scoped>
</style>